import http from '../http'

export default {
  getSessions () {
    return http.get('/session')
  },
  getSessionMessages (id) {
    return http.get(`/session/${id}/messages`)
  },
  getNoOfActiveSessions () {
    return http.get('/session/active')
  },
  getNoOfCompletedSessions () {
    return http.get('/session/completed')
  },
  getContactCustomerCare () {
    return http.get('/session/contactcenter')
  },
  getPayForInsurance () {
    return http.get('/session/payforinsurance')
  },
  getPayForInsuranceRecords () {
    return http.get('/session/payforinsurance/records')
  },
  getContactCustomerCareRecords () {
    return http.get('/session/contactcenter/records')
  },
  getReferenceTransactions () {
    return http.get('/session/reference')
  },
  getReferenceRecords (payload) {
    return http.get(`/session/reference/records?per_page=${payload.perPage}&page=${payload.page}&search=${payload.search}`)
  },
  getStickerRecords (payload) {
    return http.get(`/session/sticker/records?per_page=${payload.perPage}&page=${payload.page}&search=${payload.search}`)
  },
  downloadReferenceRecords () {
    return http.get('/session/reference/export', { responseType: 'blob' })
  }
}
